import Button from "ui/Button";

export const SUPPRT_BROWSER = "browser"

const SupportButton = ({ supportType, kind, children, ...props }) => {

    const supprtDomain = "https://support.adam-webcast.com"
    let basename = ""

    switch (supportType) {
        case SUPPRT_BROWSER:
            basename = "troubleshooting/recommended-browser"
            break
        default:
            basename = ""
    }

    if (!kind) {
        kind = "ghost"
    }

    if (!children) {
        children = "Go to Support"
    }

    const newProps = {
        ...props,
        kind: kind,
        onClick: () => window.open(`${supprtDomain}/${basename}`)
    }
    return <Button {...newProps}>{children}</Button>;
};

export default SupportButton
